import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';

export const useIsSeller = (): boolean => {
    const profile = useProfile() || {};
    return !!profile?.personalInfo?.isSeller;
};
